import icons from "trumbowyg/dist/ui/icons.svg"
import "trumbowyg/dist/ui/trumbowyg.min.css"
import "trumbowyg/dist/trumbowyg.min.js"
import "trumbowyg/dist/langs/he.min"
import "trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js"
import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css"
import "trumbowyg/dist/plugins/allowtagsfrompaste/trumbowyg.allowtagsfrompaste.min.js"
// import "trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.min" //removes too many from the whole text. If it's required it has to be rewritten.
import "trumbowyg/dist/plugins/emoji/trumbowyg.emoji.min.js"
import "trumbowyg/dist/plugins/emoji/ui/trumbowyg.emoji.min.css"
// import "trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js" // causing build err
import "./trumbowyg/trumbowyg.tags"

const path = document.currentScript.src.split('?')[0].split('/').slice(0, -2).join('/') + '/'
$.trumbowyg.svgPath = path + icons
